import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

export default function SideMenu({ isOpen, onClose }) {
  const [aboutOpen, setAboutOpen] = useState(false);
  const [participateOpen, setParticipateOpen] = useState(false);

  // Reset dropdowns when menu closes
  useEffect(() => {
    if (!isOpen) {
      setAboutOpen(false);
      setParticipateOpen(false);
    }
  }, [isOpen]);

  const handleLinkClick = () => {
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && <div className="side-menu-overlay" onClick={onClose} />}
      
      {/* Side Menu */}
      <div className={`side-menu ${isOpen ? 'open' : ''}`}>
        <div className="side-menu-header">
          <h3 className="side-menu-title">MENU</h3>
          <button className="close-btn" onClick={onClose} aria-label="Close menu">
            ✕
          </button>
        </div>

        <ul className="side-menu-list">
          <li>
            <NavLink to="/" onClick={handleLinkClick}>
              Home
            </NavLink>
          </li>

          <li>
            <button 
              className="menu-expand-btn" 
              onClick={() => setAboutOpen(o => !o)}
              aria-expanded={aboutOpen}
            >
              <span>About Us</span>
              <span className={`arrow ${aboutOpen ? 'open' : ''}`}>▾</span>
            </button>
            <div className={`submenu-wrapper ${aboutOpen ? 'open' : ''}`}>
              <ul className="submenu">
                <li>
                  <NavLink to="/TexasIslamicConference" onClick={handleLinkClick}>
                    Texas Islamic Conference
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/MeetTheTeam" onClick={handleLinkClick}>
                    Meet the Team
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/Sponsors" onClick={handleLinkClick}>
                    Sponsors
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          <li>
            <button 
              className="menu-expand-btn" 
              onClick={() => setParticipateOpen(o => !o)}
              aria-expanded={participateOpen}
            >
              <span>Participate</span>
              <span className={`arrow ${participateOpen ? 'open' : ''}`}>▾</span>
            </button>
            <div className={`submenu-wrapper ${participateOpen ? 'open' : ''}`}>
              <ul className="submenu">
                <li>
                  <NavLink to="/Donations" onClick={handleLinkClick}>
                    Donations
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/Registration" onClick={handleLinkClick}>
                    Registration
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/ProgramDetails" onClick={handleLinkClick}>
                    Program Details
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/VisitingBCS" onClick={handleLinkClick}>
                    Visiting BCS
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          <li>
            <NavLink to="/ContactUs" onClick={handleLinkClick}>
              Contact Us
            </NavLink>
          </li>
        </ul>
      </div>
    </>
  );
}